import {
    GET_FLAT_TRANSFER_PREVIEW,
    EXECUTE_FLAT_TRANSFER,
    GET_FLAT_TRANSFER_HISTORY,
    GET_FLAT_TRANSFER_DETAIL,
    REVERSE_FLAT_TRANSFER,
    ADD_FLAT_TRANSFER_DOCUMENT
} from '../../index.types';

// Preview a Flat Transfer
export const getFlatTransferPreview = (data) => ({
    type: GET_FLAT_TRANSFER_PREVIEW,
    data
});

// Execute a Flat Transfer
export const executeFlatTransfer = (data) => ({
    type: EXECUTE_FLAT_TRANSFER,
    data
});

// Get Flat Transfer History
export const getFlatTransferHistory = (data) => ({
    type: GET_FLAT_TRANSFER_HISTORY,
    data
});

// Get Flat Transfer Detail
export const getFlatTransferDetail = (data) => ({
    type: GET_FLAT_TRANSFER_DETAIL,
    data
});

// Reverse a Flat Transfer
export const reverseFlatTransfer = (data) => ({
    type: REVERSE_FLAT_TRANSFER,
    data
});

// Attach Document to a Flat Transfer
export const addFlatTransferDocument = (data) => ({
    type: ADD_FLAT_TRANSFER_DOCUMENT,
    data
});
